var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummaryCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "bright-stroke",
    x: 1,
    y: 6,
    width: 40,
    height: 28,
    stroke: "#D0D7DE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "deep-stroke",
    d: "M13.001 24.5008H23.2256M13.001 27.5008H28.9939M13.001 13.4129L14.5969 12.5436V19.5M22.1777 19.3261L17.7888 19.3257C19.7837 17.4417 22.3545 15.0063 21.3797 13.413C20.4049 11.8565 17.7888 12.5435 17.7888 14.2825M24.6102 18.108C24.7872 18.5285 25.1366 18.8831 25.5964 19.1089C26.0562 19.3348 26.5968 19.4174 27.1225 19.342C27.6481 19.2666 28.1249 19.0382 28.4684 18.6972C28.8119 18.3562 28.9999 17.9245 28.9991 17.4788C28.9991 15.5 25.8072 15.7 25.8072 15.7C25.8072 15.7 28.4033 15.7618 28.4187 14.0467C28.4194 13.682 28.2656 13.3288 27.9845 13.0498C27.7035 12.7708 27.3134 12.5839 26.8833 12.5222C26.4532 12.4606 26.0109 12.5281 25.6347 12.7129C25.2585 12.8977 24.9727 13.1878 24.8279 13.5319",
    stroke: "#AFB8C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryCard);
export default __webpack_public_path__ + "static/media/summary-card.78008a16fa7ed6b1a9bd95d57cb2a47b.svg";
export { ForwardRef as ReactComponent };